// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import request, { setupRequest } from "@/utils/request";
import { loginRedirectRoute } from "@/utils/authTabQuery";
import store from "@/store/index";
import SIdentify from "@/view/login/identify"; //注意引入路径
import * as echarts from "echarts";
import VueClipboard from "vue-clipboard2";
import jquery from "jquery";
import "@/icons";
import "@/style/style.css";
import StatusDialog from "@/components/statusDialog";
import FormDialog from "@/components/formDialog";
import IconSvg from "./components/SvgIcon";
import VueCropper from "vue-cropper";
import VueResource from "vue-resource";
import pinyin from "js-pinyin";
import filters from "@/filters/index";
import "babel-polyfill";
import vueToPdf from "vue-to-pdf";
import x2js from "x2js"; //xml数据处理插件
import vcolorpicker from "vcolorpicker";
Vue.use(vcolorpicker);
Vue.prototype.$x2js = new x2js(); //创建x2js对象，挂到vue原型上

// import VueEasyPrinter from 'vue-easy-printer';
// import htmlToPdf from '@/components/utils/htmlToPdf';
Vue.use(vueToPdf);

// Vue.use(VueEasyPrinter);
// Vue.use(htmlToPdf);
Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title;
  }
});

Vue.use(VueResource);
Vue.use(VueCropper);
Vue.component("svg-icon", IconSvg);
Vue.use(StatusDialog);
Vue.use(FormDialog);
Vue.prototype.$echarts = echarts;
Vue.use(SIdentify);
Vue.use(VueClipboard);
Vue.use(ElementUI);

Object.keys(filters).forEach(filterName => {
  Vue.filter(filterName, filters[filterName]);
});

Vue.config.productionTip = false;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
axios.defaults.transformRequest = [
  function(data) {
    let ret = "";
    for (let it in data) {
      ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
    }
    return ret;
  }
];
/** 登录失效只处理一次，避免并发 300 排队弹出多个 MessageBox */
let unauthorizedHandling = false;
function handleUnauthorized(query) {
  if (unauthorizedHandling) return;
  unauthorizedHandling = true;

  ElementUI.MessageBox.alert("当前登录已失效，请重新登录", {
    confirmButtonText: "确定",
    type: "error",
    center: true
  })
    .then(() => {
      router.push(
        loginRedirectRoute(
          query || (router.currentRoute && router.currentRoute.query)
        )
      );
    })
    .catch(() => {})
    .finally(() => {
      // 短延迟解锁：吃掉并发/迟到的 300，同时不影响重新登录后再过期的提示
      setTimeout(() => {
        unauthorizedHandling = false;
      }, 2000);
    });
}

Vue.prototype.tokenInvalid = function(res) {
  //tokenInvalid是函数名
  if (res.data && res.data.code == 300) {
    handleUnauthorized(this.$route && this.$route.query);
  }
};

/** 封装 axios：请求/响应拦截（新代码用 this.$request） */
setupRequest({
  onUnauthorized() {
    handleUnauthorized(router.currentRoute && router.currentRoute.query);
  }
});

axios.defaults.baseURL = "/api";
Vue.prototype.$axios = axios;
Vue.prototype.$request = request;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  axios,
  store,
  jquery,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js